import React from 'react'
  
export default function Page3() {
    return (
        <div>
            <h1>Writings</h1>
        </div>
    )
}